<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Вебхуки Yuma</strong>
                </CCardHeader>
                <CCardBody>
                    <div v-if="loading" class="text-center py-4">Загрузка...</div>
                    <template v-else>
                        <CAlert v-if="error" color="danger" class="mb-3" dismissible @close="error = null">
                            {{ error }}
                        </CAlert>

                        <div class="mb-4 p-3 border border-gray-300 rounded-md bg-gray-50">
                            <div class="flex items-center justify-between">
                                <div>
                                    <div class="font-bold mb-1">Режим обработки заказов</div>
                                    <div class="text-sm text-gray-600">
                                        <span v-if="webhooksEnabled">
                                            Вебхуки активны — Yuma присылает смену статуса сразу. Крон остаётся запасным опросом раз в 2 минуты.
                                        </span>
                                        <span v-else>
                                            Вебхуки отключены — статусы заказов обновляются только через крон.
                                        </span>
                                    </div>
                                    <div v-if="webhookUrl" class="text-xs text-gray-500 mt-1">
                                        URL: <code>{{ webhookUrl }}</code>
                                    </div>
                                    <div v-else class="text-xs text-red-500 mt-1">
                                        YUMA_WEBHOOK_URL не задан — регистрация невозможна
                                    </div>
                                </div>
                                <CBadge :color="webhooksEnabled ? 'success' : 'secondary'" class="px-3 py-1 text-sm">
                                    {{ webhooksEnabled ? 'Вебхуки' : 'Крон' }}
                                </CBadge>
                            </div>
                        </div>

                        <div class="flex items-center justify-between mb-3">
                            <div>
                                <span class="font-medium">{{ partner.name }}</span>
                                <span class="text-xs text-gray-400 ml-1">({{ partner.alias }})</span>
                                <CBadge v-if="partner.registered === true" color="success" class="ml-2">Зарегистрирован</CBadge>
                                <CBadge v-else-if="partner.registered === false" color="danger" class="ml-2">Ошибка</CBadge>
                                <CBadge v-else color="warning" class="ml-2">Не проверен</CBadge>
                                <div v-if="partner.registrationError" class="text-xs text-red-600 mt-1 break-all">
                                    {{ partner.registrationError }}
                                </div>
                            </div>
                            <div>
                                <CButton
                                    size="sm"
                                    color="secondary"
                                    class="mr-2"
                                    :disabled="saving"
                                    @click="toggle"
                                >
                                    {{ webhooksEnabled ? 'Выключить' : 'Включить' }}
                                </CButton>
                                <CButton
                                    size="sm"
                                    color="info"
                                    :disabled="!webhookUrl || saving"
                                    @click="reregister"
                                >
                                    {{ saving ? '...' : 'Перерегистрировать' }}
                                </CButton>
                            </div>
                        </div>

                        <div v-if="webhooksError" class="text-xs text-red-600 mb-2">{{ webhooksError }}</div>
                        <div v-if="webhooks.length" class="overflow-hidden border border-gray-300 rounded-md">
                            <div class="flex items-center bg-gray-100 text-sm font-bold">
                                <div class="w-1/4 py-2 pl-3">Событие</div>
                                <div class="py-2 pl-2">Адрес</div>
                            </div>
                            <div v-for="hook in webhooks" :key="hook.webhookId" class="flex items-center border-t border-gray-300 py-2">
                                <div class="w-1/4 pl-3"><code class="text-xs">{{ hook.actionType }}</code></div>
                                <div class="pl-2 text-xs break-all">{{ hook.endpoint }}</div>
                            </div>
                        </div>
                    </template>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
export default {
    name: 'YumaHooks',

    data() {
        return {
            loading: true,
            saving: false,
            error: null,
            webhooksEnabled: true,
            webhookUrl: null,
            webhooksError: null,
            webhooks: [],
            partner: {
                alias: 'yoy',
                name: 'Yuma',
                registered: null,
                registrationError: null
            }
        };
    },

    async created() {
        await this.fetchData();
    },

    methods: {
        async fetchData() {
            try {
                const { data } = await this.axios.get('/integration/yuma/hooks');
                this.webhooksEnabled = data.webhooksEnabled;
                this.webhookUrl = data.webhookUrl;
                this.webhooksError = data.webhooksError;
                this.webhooks = data.webhooks || [];
                this.partner = data.partner;
            } catch (e) {
                this.error = e?.response?.data?.error || e?.message || 'Ошибка загрузки';
            } finally {
                this.loading = false;
            }
        },

        async toggle() {
            this.saving = true;
            this.error = null;
            try {
                await this.axios.post('/integration/yuma/hooks/register', {
                    enabled: !this.webhooksEnabled
                });
                await this.fetchData();
            } catch (e) {
                this.error = e?.response?.data?.error || e?.message || 'Не удалось переключить режим';
            } finally {
                this.saving = false;
            }
        },

        async reregister() {
            this.saving = true;
            this.error = null;
            try {
                await this.axios.post('/integration/yuma/hooks/reregister', {}, { timeout: 60000 });
                await this.fetchData();
            } catch (e) {
                this.error = e?.response?.data?.error || e?.message || 'Не удалось перерегистрировать вебхук';
                await this.fetchData();
            } finally {
                this.saving = false;
            }
        }
    }
};
</script>
